module.exports = __webpack_public_path__ + "fonts/Sarabun-ExtraBold.4ce35744.ttf";